import { render, staticRenderFns } from "./dialogDrag.vue?vue&type=template&id=858f96b0"
import script from "./dialogDrag.vue?vue&type=script&lang=js"
export * from "./dialogDrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports